// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-de8a9206], h4[data-v-de8a9206] {\n\tcolor: white;\n}\nh4[data-v-de8a9206] {\n\tpadding-bottom: 3%;\n\tpadding-top: 3%;\n}\n", ""]);
// Exports
module.exports = exports;
